import React from 'react';

import { ErrorPage } from '@tecma/ds/error-page';
import ReactDOM from 'react-dom';
import { ErrorBoundary } from 'react-error-boundary';

import App from './App';
import { Providers } from './components/App.Providers';
import reportWebVitals from './reportWebVitals';

// eslint-disable-next-line import/no-unresolved -- CSS subpaths are published through package.json exports.
import '@tecma/ds/styles/global.css';
import '@tecma/ds/styles/components.css';
import './theme/global.scss';

ReactDOM.render(
  <React.StrictMode>
    <Providers>
      <ErrorBoundary
        FallbackComponent={() => <ErrorPage logo='' />}
        onError={(error, info) => {
          // eslint-disable-next-line no-console
          console.error('[ITD ErrorBoundary]', error, info);
        }}
      >
        <App />
      </ErrorBoundary>
    </Providers>
  </React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
